import { computed, reactive } from 'vue'
import type { ValidationValue } from '../../components/OenUiInputValidation/types'
import { useComponentId } from '../useComponentId/index'

export function useValidationHelpers(validation: ValidationValue<any>) {
  const validationId = useComponentId('validation')
  const hasError = computed(() => {
    return validation && validation.$dirty && validation.$anyInvalid
  })

  const isValid = computed(() => {
    return validation && validation.$dirty && !validation.$anyInvalid
  })
  const ariaDescribedBy = computed(() => {
    return validation && validation.$anyInvalid && validationId
  })
  const ariaInvalid = computed(() => {
    return !!(validation && validation.$anyInvalid)
  })
  return reactive({
    validationId,
    hasError,
    isValid,
    ariaDescribedBy,
    ariaInvalid,
  })
}
